module.exports = __webpack_public_path__ + "img/banner配图.d0e3b8aa.png";